import Can from "components/Can/Can";
import { DACA_PERMISSIONS } from "constants/index";
import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import "react-toastify/dist/ReactToastify.css";
import { bindActionCreators } from "redux";
import Button from "../../components/Button/button.component";
import Searchbar from "../../components/SearchBar/searchbar.component";
import Subtitle from "../../components/Subtitle/subtitle.component";
import Table from "../../components/Table/table.component";
import Title from "../../components/Title/title.component";
import { Creators as DacaActions } from "../../store/ducks/daca";
import ToastHelper from "../../utils/toastHelper";
import CadastroDaca from "../CadastroDaca/cadastroDaca.modal";
import PesquisaAvancadaDaca from "./pesquisaAvancadaDaca";
import { validatePermission } from "utils/permissionHelper";

class ListaDaca extends Component {
	state = {
		search: "",
		isOpenCadastrar: false,
		orderIcon: {
			nome: "",
			icon: undefined
		},
		inititalOrderIcon: {
			colunaTable: "id",
			iconOrderDirection: "fas fa-arrow-down"
		}
	};

	columns = [
		{
			id: 0,
			title: "Código",
			property: "id",
			order: "id"
		},
		{
			id: 1,
			title: "Item",
			property: "nome",
			order: "nome"
		},
		{
			id: 2,
			title: "Quantidade em estoque",
			property: "quantidadeEstoque"
		}
	];

	actions = () => {
		if (
			validatePermission(
				[
					DACA_PERMISSIONS.GERENCIAR_ITEM,
					DACA_PERMISSIONS.GERENCIAR_ENTRADA,
					DACA_PERMISSIONS.GERENCIAR_SAIDA,
					DACA_PERMISSIONS.GERENCIAR_SAIDA_REGIONAL,
					DACA_PERMISSIONS.GERENCIAR_DEVOLUCAO,
					DACA_PERMISSIONS.GERENCIAR_DEVOLUCAO_REGIONAL,
					DACA_PERMISSIONS.GERENCIAR_MOVIMENTACAO,
					DACA_PERMISSIONS.GERENCIAR_MOVIMENTACAO_REGIONAL
				],
				this.props.usuario.soeAcoes
			)
		) {
			return [
				{
					id: 0,
					name: "Gerenciar item",
					icon: "fas fa-cogs",
					action: item => this.handleGerenciar(item)
				}
			];
		}
		return [
			{
				id: 0,
				name: "Visualizar item",
				icon: "fas fa-search",
				action: item => this.handleGerenciar(item)
			}
		];
	};

	componentDidMount() {
		this.resetarLista();
	}

	handlePaginacao = pagina => {
		const { Filter } = this.props;
		const {
			search,
			filtroAvancado,
			pesquisaAvancada,
			ordemDirecao,
			ordem
		} = this.state;

		if (!pesquisaAvancada) {
			const f = {
				pagina,
				pesquisaSimples: search || null,
				ordemDirecao,
				ordem
			};
			Filter.dacaFiltro(f);
		} else {
			Filter.dacaFiltro({
				...filtroAvancado,
				pagina,
				ordemDirecao,
				ordem
			});
		}
	};

	handleSearchByOrder = ordem => {
		const {
			props: { Filter },
			state: { search, ordemDirecao, pesquisaAvancada, filtroAvancado }
		} = this;

		let filtro = { pagina: 0 };

		if (!pesquisaAvancada) {
			filtro.pesquisaSimples = search;
		} else {
			filtro = { ...filtro, ...filtroAvancado };
		}

		if (!ordemDirecao || ordemDirecao === "DESC") {
			filtro.ordemDirecao = "ASC";
		} else if (ordemDirecao === "ASC") {
			filtro.ordemDirecao = "DESC";
		}

		this.setState({ ordemDirecao: filtro.ordemDirecao, ordem });

		filtro.ordem = ordem;
		Filter.dacaFiltro(filtro);

		return filtro.ordemDirecao;
	};

	handleCadastrarDaca = () => {
		const { history } = this.props;
		history.push("/cadastrodaca");
	};

	handleGerenciar = item => {
		const { history } = this.props;
		history.push(`/listadaca/gerenciaitem/${item.id}`);
	};

	handleChangeSearchInput = e => {
		this.setState({
			search: e.target.value
		});
	};

	handleSearch = () => {
		const {
			props: { Filter },
			state: { search, ordemDirecao, ordem }
		} = this;

		if (ordem) {
			Filter.dacaFiltro({
				pesquisaSimples: search || null,
				pagina: 0,
				ordemDirecao,
				ordem
			});
		} else {
			Filter.dacaFiltro({
				pesquisaSimples: search || null,
				pagina: 0
			});
		}
	};

	handleKeyPress = event => {
		if (event.key === "Enter") {
			event.preventDefault();
			this.handleSearch();
		}
	};

	/*
		MODAL CADASTRAR
	*/

	handleOpenCadastrar = () => {
		this.setState({ isOpenCadastrar: true });
	};

	handleCloseCadastrar = () => {
		this.setState({ isOpenCadastrar: false });
	};

	createModelDaca = daca => {
		const dacaModel = { ...daca };

		if (daca.permanente === false) {
			dacaModel.patrimoniado = false;
		}

		return dacaModel;
	};

	handleSubmitCadastrar = async values => {
		const { Filter } = this.props;

		const dacaFormatado = this.createModelDaca(values);

		await Filter.dacaSalvar(dacaFormatado, () => {
			ToastHelper.success("Estoque salvo com sucesso!");
			Filter.dacaReset();
			this.setState({ isOpenCadastrar: false });
			this.resetarLista(); // Chamando para recarregar listagem após concluir cadastro
		});
	};

	createModalCadastrar = ({ isOpenCadastrar }) =>
		isOpenCadastrar && (
			<CadastroDaca
				isOpenCadastrar={isOpenCadastrar}
				handleCloseCadastrar={this.handleCloseCadastrar}
				handleSubmitCadastrar={this.handleSubmitCadastrar}
			/>
		);

	resetarLista = () => {
		const { Filter } = this.props;
		this.resetIconOrder();
		Filter.dacaFiltro({ pagina: 0 });
	};

	resetIconOrder = () => {
		this.setState({ orderIcon: { icon: undefined, nomeColuna: "" } });
	};

	pesquisaAvancada = () => {
		const { Filter } = this.props;
		const { pesquisaAvancada } = this.state;

		return (
			pesquisaAvancada && (
				<PesquisaAvancadaDaca
					handlePesquisaSimplificada={() => {
						this.resetarLista();
						this.setState({ pesquisaAvancada: false });
					}}
					handleSearch={values => {
						const filtroAvancado = {
							...values,
							localExibicao: values.localExibicao.map(
								exibicao => exibicao.value
							),
							tipoItem: values.tipoItem.map(tipo => tipo.value),
							pagina: 0,
							simplificado: false
						};
						Filter.dacaFiltro(filtroAvancado);
						this.setState({ filtroAvancado });
					}}
					handleClear={({ resetForm }) => {
						this.resetarLista();
						resetForm();
					}}
				/>
			)
		);
	};

	ordenar = ordem => {
		if (ordem) {
			const direcaoOrdemFiltro = this.handleSearchByOrder(ordem);
			if (direcaoOrdemFiltro === "DESC") {
				this.setState({
					orderIcon: { icon: "fas fa-arrow-down", nomeColuna: ordem }
				});
			} else {
				this.setState({
					orderIcon: { icon: "fas fa-arrow-up", nomeColuna: ordem }
				});
			}
		}
	};

	pesquisaSimplificada(search) {
		const { pesquisaAvancada } = this.state;
		return (
			!pesquisaAvancada && (
				<div>
					<div>
						<Searchbar
							value={search}
							onClick={this.handleSearch}
							onKeyPress={this.handleKeyPress}
							onChange={this.handleChangeSearchInput}
							placeholder="Pesquise por item"
						/>
					</div>
					<div className="mt-2">
						<button
							type="button"
							onClick={() => {
								this.setState({
									pesquisaAvancada: true,
									search: undefined
								});
								this.resetarLista();
							}}
							className="btn btn-link pl-0"
						>
							Pesquisa avançada
						</button>
					</div>
				</div>
			)
		);
	}

	render() {
		const {
			props: {
				lista,
				totalPages,
				indicePagina,
				totalElements,
				totalItemPages
			},
			state: { search, orderIcon, inititalOrderIcon }
		} = this;

		if (orderIcon && !orderIcon.icon && inititalOrderIcon) {
			orderIcon.nomeColuna = inititalOrderIcon.colunaTable;
			orderIcon.icon = inititalOrderIcon.iconOrderDirection;
		}
		return (
			<Fragment>
				<div className="row">
					<div className="col-md-12">
						<Title>Estoque DACA</Title>
					</div>
				</div>

				<div className="card">
					<div className="card-body">
						{this.pesquisaAvancada()}
						{this.pesquisaSimplificada(search)}
					</div>
				</div>

				<div />

				<div className="card mt-5">
					<div className="container d-flex mt-3">
						<div>
							<Subtitle nopadding="true">
								Listagem de estoque
							</Subtitle>
						</div>
						<div className="ml-auto">
							<Can
								perform={DACA_PERMISSIONS.GERENCIAR_ITEM}
								yes={() => (
									<Button
										type="button"
										primary
										icon="fas fa-plus"
										text="Cadastrar item"
										onClick={this.handleOpenCadastrar}
									/>
								)}
								no={() => null}
							/>
						</div>
					</div>

					<div className="card-body">
						<Can
							perform={DACA_PERMISSIONS.VISUALIZAR}
							yes={() => (
								<Table
									showPaginate
									align="left"
									columns={this.columns}
									actions={this.actions()}
									data={lista}
									totalPages={totalPages}
									currentPage={indicePagina}
									onChangePage={page =>
										this.handlePaginacao(page)
									}
									acoesSingleButton={true}
									emptyMessage="Não há itens cadastrados."
									emptyColSpan={this.columns.length + 1}
									totalElements={totalElements}
									totalItemPages={totalItemPages.length}
									isOrderByGrid
									orderIcon={orderIcon}
									ordenar={this.ordenar}
									permission={[DACA_PERMISSIONS.VISUALIZAR]}
								/>
							)}
						/>
					</div>
				</div>
				{this.createModalCadastrar(this.state)}
			</Fragment>
		);
	}
}

const mapStateToProps = state => ({
	lista: state.daca.lista.content,
	totalPages: state.daca.lista.totalPages,
	indicePagina: state.daca.lista.pageable.pageNumber,
	totalPaginas: state.daca.lista.totalElements,
	totalElements: state.daca.lista.totalElements,
	totalItemPages: state.daca.lista.content,
	usuario: state.auth.usuario
});

const mapDispatchToProps = dispatch => ({
	Filter: bindActionCreators(DacaActions, dispatch)
});

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(ListaDaca);
